import React from "react";

import './ContactMap.css'

const ContactMap = () => {

  return (
    <section className="ContactMap container-fluid mx-0 px-0" data-aos="fade-in" data-aos-easing data-aos-duration="1000" data-aos-once="true">
      <iframe className="ContactMap-iframe" title="Google Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.449507117563!2d-73.99289994943965!3d40.75213714299526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25991b6a3384f%3A0x6eb5fc46844b8db1!2sAdvanced%20Copy%20Center%2C%20Inc.!5e0!3m2!1sen!2sus!4v1586014963056!5m2!1sen!2sus" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
    </section>
  );

}

export default ContactMap;